<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="数据来源">
      <el-select v-model="form.dataSource" placeholder="请选择" filterable @change="selectChange">
        <el-option
          v-for="item in columnData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <layoutConfig
      :config="config"
      :layoutWidth="layoutWidth"
      :layout="layout"
      @layoutChange="layoutChange"
    />
  </el-form>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import { treeToOneArray } from '@/assets/js/Common'
import { listType } from '../../js/config'
import layoutConfig from './LayoutConfig'

const columnApi = new ColumApi()
export default {
  props: ['configData', 'layoutData', 'mode', 'layoutWidth', 'layout'],
  components: {
    layoutConfig,
  },
  data() {
    return {
      form: {
        dataSource: '', // 数据来源
      },
      columnName: '',
      config: {
        component: listType[0].value,
        w: 10,
        h: 10,
      },
      columnData: [],
      listType,
      defaultExpandedKeys: [],
      columnFlattenData: [],
    }
  },
  watch: {
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.form = this.$options.data().form
        if (!_.isEmpty(val)) {
          _.assign(this.form, val)
        } else {
          this.selectChange()
        }
      },
    },
    layoutData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.config = _.pick(this.layoutData, ['w', 'h', 'type', 'x', 'y', 'i'])
        }
      },
    },
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columnApi.tree(0)
      if (!err) {
        const data = treeToOneArray(res, 'child')
        this.columnData = _.filter(data, (item) => {
          return item.type === this.config.type
        })
      }
    },
    selectChange() {
      this.$emit('configChange', this.form)
    },
    layoutChange(val) {
      this.config = _.cloneDeep(val)
      this.$emit('layoutChange', val)
    },
  },
  created() {
    this.getColumnData()
  },
}
</script>

<style lang="scss">
.data-source-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
<style lang="scss" scoped>
.data-source-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
